import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
import api from "@/api";
import { ElMessage } from "element-plus";
import ButtonDialog from "@/components/ButtonDialog.vue";
export default {
  name: "SitePageListView",
  components: {
    ButtonDialog,
    BatterTableDataView
  },
  props: {
    site: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      curPageId: null,
      initQuery: null,
      batchSelected: []
    };
  },
  methods: {
    createHotSearch(pid) {
      this.curPageId = pid;
      this.$refs.createHotSearch.open();
    },
    onRowSelectChange(rows) {
      this.batchSelected = rows.map(r => r.id);
    },
    updateVisible(page, val) {
      api.updateSitePageVisible({
        pageId: page.id,
        visible: val
      }).then(() => {
        ElMessage.success('更新成功');
      });
    },
    gotoEdit(d) {
      window.open('/html/edit/' + d.htmlId, '_blank');
    },
    previewHtml(d) {
      window.open(`/html/preview/${d.htmlId}?footer=${d.footId ? d.footId : ''}&page=${d.id}`, '_blank');
    },
    previewHtmlInSite(d) {
      var link = this.site.extra.DOMAIN + '/';
      if (d.nav.extra.PATH.endsWith('/')) {
        link += d.nav.extra.PATH;
      } else {
        link += d.nav.extra.PATH + '/';
      }
      if (d.subNav) {
        if (d.subNav.extra.PATH.endsWith('/')) {
          link += d.subNav.extra.PATH;
        } else {
          link += d.subNav.extra.PATH + '/';
        }
      }
      link += d.createdTime.substring(0, 10).replaceAll('-', '');
      link += d.id;
      link += '.html';
      link = 'https://' + link.replaceAll('//', '/');
      console.log('GOTO', link);
      window.open(link, '_blank');
    },
    init() {
      this.initQuery = {
        siteId: this.site.value,
        refId: this.site.value
      };
    }
  },
  mounted() {
    this.init();
  }
};